import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { isUndefined } from 'util';
import { LoggingService } from '../../../services/logging.service';

@Component({
    selector: 'app-registeration-success',
    templateUrl: './registeration-success.component.html',
    styleUrls: ['./registeration-success.component.less']
})
export class RegistrationSuccessComponent implements OnInit
{
    email;

    constructor(private router: Router) { }

    ngOnInit()
    {
        this.email = (this.router.parseUrl(this.router.url)).queryParams.email;
        LoggingService.log(this.email);

        if (isUndefined(this.email))
        {
            this.router.navigate(['/welcome']);
            return;
        }
    }

    goToMain(e: Event)
    {
        this.router.navigate(['/welcome']);
    }

    resendConfirmation(e: Event)
    {
        this.router.navigateByUrl('register/resend');
    }

}
